export default "/images/my-urban.png?85b5a5128f03abb2d946d2f3278bb929";